export const SITE = {
  name: "Toscana",
  fullName: "Toscana Cocinas Integrales",
  tagline: "Diseñamos el corazón de tu hogar",
  phoneDisplay: "+52 452 132 6712",
  phoneHref: "tel:+524521326712",
  whatsappDisplay: "+52 452 132 6712",
  whatsappHref:
    "https://wa.me/524521326712?text=Hola%2C%20quiero%20cotizar%20mi%20cocina%20integral",
  facebook: "https://www.facebook.com/profile.php?id=100076360535454",
  instagram: "https://www.instagram.com/cocinastoscana",
  tiktok: "https://www.tiktok.com/@toscana.cocinas",
  email: "toscanacocinasintegrales1@gmail.com",
  address: "Zamacoyahuac 34, Col. México, Uruapan, Michoacán. C.P. 60153",
  mapsHref:
    "https://www.google.com/maps/search/?api=1&query=Zamacoyahuac+34+Col.+M%C3%A9xico+Uruapan+Michoac%C3%A1n+60153",
  googleBusiness:
    "https://www.google.com/maps/search/?api=1&query=Toscana+Cocinas+Integrales+Zamacoyahuac+34+Uruapan+Michoac%C3%A1n",
  googleReviewCount: "",
  hours: [
    { days: "Lunes a Sábado", time: "9:00 – 19:00" },
    { days: "Domingo", time: "Cerrado" },
  ],
  holidays:
    "Cerramos todos los días feriados de México: 1 de enero (Año Nuevo), primer lunes de febrero, tercer lunes de marzo, 1 de mayo, 5 de mayo, 16 de septiembre, tercer lunes de noviembre, 12 de diciembre y 24 y 25 de diciembre (Navidad).",
  serviceAreas: ["Apatzingán", "Morelia", "Lázaro Cárdenas", "Los Reyes", "Ixtapa"],
};

export const NAV_LINKS = [
  { label: "Servicios", href: "#servicios" },
  { label: "Portafolio", href: "#portafolio" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Contacto", href: "#contacto" },
];
